export default {"src":"/_next/static/media/fotterBgImage.8b9606b3.svg","height":675,"width":484,"blurWidth":0,"blurHeight":0};